export const originsObject = {
  "http://localhost:3008": "http://localhost:8080",
  "https://entitiesdev.standards.ieee.org":
    "https://myprojectdev.standards.ieee.org",
  "https://entitiesqa.standards.ieee.org":
    "https://myprojectqa.standards.ieee.org",
  "https://entitiesuat.standards.ieee.org":
    "https://myprojectuat.standards.ieee.org",
  "https://entities.standards.ieee.org":
    "https://development.standards.ieee.org",
};

export const entitiesOriginsObject = {
  "http://localhost:3008": "http://localhost:8080",
  "https://entitiesdev.standards.ieee.org":
    "https://entitiesdev-secure.standards.ieee.org",
  "https://entitiesqa.standards.ieee.org":
    "https://entitiesqa-secure.standards.ieee.org",
  "https://entitiesuat.standards.ieee.org":
    "https://entitiesuat-secure.standards.ieee.org",
  "https://entities.standards.ieee.org":
    "https://entities-secure.standards.ieee.org",
};

export const entitiesSignoutOriginObject = {
  "http://localhost:3008":
    "https://services10qa.ieee.org/ext/ieeeresponsivelogout",
  "https://entitiesdev.standards.ieee.org":
    "https://services10qa.ieee.org/ext/ieeeresponsivelogout",
  "https://entitiesqa.standards.ieee.org":
    "https://services10qa.ieee.org/ext/ieeeresponsivelogout",
  "https://entitiesuat.standards.ieee.org":
    "https://services10qa.ieee.org/ext/ieeeresponsivelogout",
  "https://entities.standards.ieee.org":
    "https://services10.ieee.org/ext/ieeeresponsivelogout",
};

export const BASEURL =
  originsObject[window.location.origin] +
  "/myproject-web/rest/api/public/entities";
export const PUBLICURL =
  originsObject[window.location.origin] + "/myproject-web/rest/api/public";
export const ABSOLUTE_BASE_URL =
  originsObject[window.location.origin] + "/myproject-web";

export const LOGINPAGE =
  entitiesOriginsObject[window.location.origin] +
  "/myproject-web/rest/api/public/entities/isvalidentityuser";

export const UNAUTHRIZEDPAGE = `${window.location.origin}/#/unauth`;
export const SIGNOUTPAGE = `${window.location.origin}/#/signout`;

export const STATUS_DONE = 200;
export const STATUS_SUCCESS = 0;

// Time limits due to inactivity
export const LOGOUT_WARN_TIME = 3480000; // 58 min
export const LOGOUT_AUTO_TIME = 120000; // 2 min after warning is shown, logout is user doesnt respond

// Number of records per page on table
export const RECORDSPERPAGE = 20;
export const RECORDSPERPAGEFORADVANCED = 50;

// Number of character limit
export const SHOWLESSLIMIT = 30;

export const SERVICE_UNAVAILABLE =
  "Service is not available at this time. Please try again later or contact standards-support@ieee.org for further assistance.";

export const EMPTY = "";
export const TIER4 = "Tier 4";
export const TIER3 = "Tier 3";
export const TIER2 = "Tier 2";
export const TIER1 = "Tier 1";

export const TRUE = "true";
export const FALSE = "false";

export const HTTP_GET = "GET";
export const HTTP_POST = "POST";
export const HTTP_PUT = "PUT";
export const HTTP_DELETE = "DELETE";

export const ORDER_ASC = "asc";
export const ORDER_DESC = "desc";

// Number of character limit for text field
export const MAX_CHAR_LIMIT = 2000;

export const DD_MMM_YYYY = "DD MMM YYYY";
export const EXPORT_EXCEL = "XLSX";
export const EXPORT_CSV = "CSV";
export const GROUPS = "GROUPS";
export const BALLOTS = "BALLOTS";

export const ENTITY = "ENTITY";
export const ACTIVE = "ACTIVE";
export const COMPLETED = "COMPLETED";
export const INACTIVE_RESERVED = "INACTIVE_RESERVED";
export const INACTIVE_WITHDRAWN = "INACTIVE_WITHDRAWN";
export const WITHDRAWN_STD = "WITHDRAWN_STD";

export const REVCOM_AGENDA = "RevCom Agenda";
export const NESCOM_AGENDA = "NesCom Agenda";
export const SA_BALLOT_COMPLETE = "SA Ballot: Ballot Complete";
export const RECIRCULATION = "Recirculation";
